import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-main-layout',
    template: `
    <app-navigation class="app-wrapper"></app-navigation>
  `,
    styles: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppLayoutComponent {}
